import {
  Scheduler as Data,
  SchedulerCollection as Collection,
} from '@/typings/api/Scheduler'
import { BaseApiAuth } from '@/api/BaseApiAuth'

export class SchedulerApi extends BaseApiAuth<Data, Collection> {
    protected readonly endpoint = 'data-collection/scheduler_limits';

    public getDownloadUrl() {
      const path = 'download/'
      const [url] = this.getUrl(path)
      return url
    }
}
